<template class="cmp-grid-cell-detail">
  <MovingTooltip id="gridCellTooltip" v-if="showTooltip" :icon="false" :clickToView="clickToView">
    <template #content>
      <div>
        <slot name="details"></slot>
      </div>
    </template>
    <div :style="getCellColor()" class="cmp-grid-cell-detail_cell-data">
      <slot name="cell-data"></slot>
    </div>
  </MovingTooltip>
  <div v-else :style="getCellColor()" class="cmp-grid-cell-detail_cell-data">
    <slot name="cell-data"></slot>
  </div>
</template>

<script>

import MovingTooltip from "@/components/common/other/MovingTooltip"

export default {
  name: "GridCellDetail",
  components: {
    MovingTooltip
  },

  methods: {

    getCellColor() {

      if(this.textColor) {
        return 'color:' + this.textColor;
      }

      if(this.cellColor) {
        return 'background:' + this.cellColor + ';color: white';

      } else if(this.notGridCell) {
        return 'background: #fff' + ';color: black;';
      }

    }
  },

  props: {

    showTooltip: {type: Boolean, default: true},
    notGridCell: {type: Boolean, default: false},
    clickToView: {type: Boolean, default: false},
    textColor: String,
    cellColor: String,

  }
}
</script>

<style lang="scss" scoped>

.cmp-grid-cell-detail {

  &_cell-data {
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 4px;
    width: 58px;
    height: 22px;
    display: flex;
    align-items: center;
  }

}

</style>
